import React from "react";
import { Grid } from "@mui/material";
import MainTitle from "../../../muiHome/mainTitle";
import FacultyCard from "../../../muiCommonComponent/facultyCards";

const FacultyList=()=>{
    const facultyList=[
        {img:'/assets/img/SBMC/sumitNEW.png',name:'Sumit',position:'Assistant Professor',email:'sumit.soet@mvn.edu.in',gs: "https://scholar.google.com/citations?user=cUgmsSMAAAAJ&hl=en",
        linkedin: "https://www.linkedin.com/in/sumit-kumar-65350130b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        orcid: "https://orcid.org/0000-0002-8747-836X",
        rg: "https://www.researchgate.net/profile/Sumit-Sumit-12?ev=hdr_xprf",
        website: "#",
        aoi: "IOT & Machine Learning",
        education: "Ph.D. Pursunig",
        re: "6",
        te: "6",
        iece: "N/A",
        articles:
          "13"
          ,
        books:
          "1",
        chapters:
          "",
        patents:
          "1 Published",
        membership:
          "<li>NA</li>",
        aa1: "UGC NET Dec. 2018",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},
            {
  img: "/assets/img/SOET/akshit_chopra.jpg",  // Suggested filename after downloading from Drive
  name: "Akshit Chopra",
  position: "Teaching Assistant",
  email: "akshit.chopra@mvn.edu.in", 
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/akshit-chopra-605475199?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  orcid: "NA",
  rg: "https://www.researchgate.net/profile/Akshit-Chopra-3?ev=hdr_xprf",
  website: "NA",
  aoi: "Cloud Computing/ AI",
  education: "B.Tech",
  re: "NA",
  te: "2",
  iece: "2",
  articles: "NA",
  books: "1",
  chapters: "1",
  patents: "NA",
  membership: "NA",
  aa1: "University Silver medalist in MCA",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
}
,
,{
  img: "/assets/img/SOET/amit_sagu.png",  // Suggested filename after downloading from Drive
  name: "Dr. Amit Sagu",
  position: "Head & Assistant Professor (Department of Computer Science & Engineering)",
  email: "amit.sagu@mvn.edu.in",
  gs: "https://scholar.google.com/citations?hl=en&user=gy4TiZAAAAAJ",
  linkedin: "https://www.linkedin.com/in/saguamit51/",
  orcid: "https://orcid.org/0000-0002-0129-7665",
  rg: "https://www.researchgate.net/profile/Amit-Sagu",
  website: "NA",
  aoi: "Machine Learning, internet of things, .net technology",
  education: "Ph.D.",
  re: "7 years",
  te: "6 years",
  iece: "2",
  articles: "https://www.researchgate.net/profile/Amit-Sagu",
  books: "https://scholar.google.com/citations?hl=en&user=gy4TiZAAAAAJ",
  chapters: "NA",
  patents: "1",
  membership: "NA",
  aa1: "Junior research fellowship award by UGC india",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/shashi_kant_singh.jpg",  // Suggested filename after downloading from Drive
  name: "Shashi Kant Singh",
  position: "Assistant Professor",
  email: "shashikant.singh@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/shashi-kant-singh-741824370?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app ",
  orcid: "https://orcid.org/0009-0001-7853-2862",
  rg: "https://www.researchgate.net/profile/Shashi-Singh-61?ev=hdr_xprf",
  website: "NA",
  aoi: "Machine Learning & IOT",
  education: "Ph.D. Pursuing",
  re: "6 MONTHS",
  te: "1.5 YEARS",
  iece: "1.5 YEARS",
  articles: "NA",
  books: "https://scholar.google.com/citations?hl=en&user=0JhO8ZQAAAAJ",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "Web Engineer Certified By Ardent Info. tech",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/daya_shankar_prasad.png",  // Suggested filename after downloading from Drive
  name: "Dr. Daya Shankar Prasad",
  position: "Head & Assistant Professor (Department of Mechnical Engineering)",
  email: "dayashankar.prasad@mvn.edu.in",
  gs: "https://scholar.google.com/citations?hl=en&user=fkPCOfkAAAAJ",
  linkedin: "https://www.linkedin.com/in/daya-shankar-prasad-43171099?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BRNSK6NGDTcyxUhujxFSP1Q%3D%3D",
  orcid: "https://orcid.org/my-orcid?orcid=0009-0004-8399-2910",
  rg: "https://www.researchgate.net/profile/Daya-Prasad?ev=hdr_xprf",
  website: "NA",
  aoi: "Heat Transfer,  Fluid Mechanics, Thermal Energy  storage, Renewable Energy, Nanomaterials and Nano Technology, Composite material, Solar Energy, Operation Research etc.",
  education: " Ph.D, M.Tech (Double Gold Medalist, MBA, B.Tech (Branch Topper)",
  re: "6.5 Years",
  te: "12 Years",
  iece: "1 year",
  articles: "26",
  books: "3",
  chapters: "NA",
  patents: "2 published",
  membership: "Member of IAENG",
  aa1: "1. Four times GATE Qualified with good percentile continuously from 2011 onward,",
  aa2: "2. I.E.S Written Examination Qualified. 3. Got Appreciation Certificate from IIT, BHU in honour of full support as Faculty Coordinator for Organising first round of Caliber “de-en-quete” from 31st March-1st April, 2018,",
  aa3: "4. Got Certificate from IIT Roorkee (NPTEL) for completing a course on “Steam Power and Gas System” in 2020., 5. Got Certificate from IIT Roorkee (NPTEL) for completing a course on “Refrigeration & Air Conditioning” in 2019, 6. Got Certificate from IIT Kharagpur (NPTEL) for completing a course on on “Concept of Thermodynamics” in 2019. 7. Got Certificate from NITTTR (NPTEL) for completing a course on “Quality Assurance through NAAC Accreditation process” in 2022.",
  aa4: "8. Gold Medalist for branch as well as NIT Patna’s topper in M.Tech. Programme., 9. Gold Medalist for branch topper in B.Tech Programme,",
  aa5: "10.  Awarded for best student in 2009 by Indian Society for Technical Education,",
  aa6: "11.  Reviewer of  Journal of Futuristic Sciences and Applications."
},
{
  img: "/assets/img/SOET/naveen_kumar_deswal.jpg",  // Suggested filename after downloading from Drive
  name: "Naveen Kumar Deswal",
  position: "Assistant Professor",
  email: "naveen.deswal@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/naveen-deshwal/",
  orcid: "NA",
  rg: "NA", 
  website: "NA",
  aoi: "Web development, Cloud Computing",
  education: "MCA",
  re: "0",
  te: "1.7",
  iece: "2.5",
  articles: "NA",
  books: "NA",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/mansi_kumar.png",  // Suggested placeholder filename (no photo link provided)
  name: "Mansi Kumar",
  position: "Teaching Assistant",
  email: "mansi.kumar@mvn.edu.in",
  gs: "NA",
  linkedin: "www.linkedin.com/in/mansi-kumar-15305a2b1",
  orcid: "NA",
  rg: "https://www.researchgate.net/profile/Mansi-Kumar-3?ev=hdr_xprf",
  website: "NA",
  aoi: "Machine Learning ",
  education: "MCA",
  re: "NA",
  te: "1.10 Year",
  iece: "NA",
  articles: "NA",
  books: "NA",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "Qualified UGC NET June 2025",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/himanshia.png",  // Suggested filename after downloading from Drive
  name: "Himanshi",
  position: "Assistant Professor",
  email: "Himanshi.chauhan@mvn.edu.in ",
  gs: "https://scholar.google.com/citations?user=3ljT0cgAAAAJ&hl=en",
  linkedin: "https://www.linkedin.com/in/himanshi-chauhan-78a962348?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  orcid: "https://orcid.org/0009-0001-7817-6044",
  rg: "https://www.researchgate.net/profile/Himanshi-Chauhan-7?ev=hdr_xprf",
  website: "NA",
  aoi: "Machine Learning, Business Intelligence/Power BI , Internet of things (IOT)",
  education: "Ph,D Pursuing",
  re: "NA",
  te: "1.9 Year",
  iece: "1.5 Year",
  articles: "NA",
  books: "https://scholar.google.com/citations?user=3ljT0cgAAAAJ&hl=en",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/harshita_sorout.png",  // Use default or placeholder image if photo is not provided
  name: "Harshita Sorout",
  position: "Assistant Professor",
  email: "harshita.sorout@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/harshita-sorout-ll/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  orcid: "https://orcid.org/0009-0005-2283-0544",
  rg: "https://www.researchgate.net/profile/Harshita-Sorout?ev=hdr_xprf",
  website: "NA",
  aoi: "Machine learning, AI, Data science",
  education: "Ph.D Pursuing",
  re: "NA",
  te: "10 Months",
  iece: "NA",
  articles: "NA",
  books: "NA",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "Certified in Developing AI Application on Azure from coursera, Certified in Introduction to AI with python from HarvardX, ",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/Nikhil.png",  // Suggested filename after downloading from Drive
  name: "Nikhil",
  position: "Assistant Professor",
  email: "nikhil.soet@mvn.edu.in",
  gs: "NA",
  linkedin: "NA",
  orcid: "NA",
  rg: "NA",
  website: "NA",
  aoi: "BlockChain",
  education: "MCA",
  re: "NA",
  te: "NA",
  iece: "NA",
  articles: "NA",
  books: "N",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/Priyanshi.png",  // Suggested filename after downloading from Drive
  name: "Priyanshi ",
  position: "Lecturer",
  email: "priyanshi.rawat@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/priyanshi-rawat-145130314?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  orcid: "NA",
  rg: "NA",
  website: "NA",
  aoi: "power bi , Machine Learning ",
  education: "MCA",
  re: "NA",
  te: "1.6 Year",
  iece: "NA",
  articles: "NA",
  books: "N",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/Sujeet.png",  // Suggested filename after downloading from Drive
  name: "Sujeet Kumar ",
  position: "Assistant Professor",
  email: "sujeet.kumar@mvn.edu.in",
  gs: "NA",
  linkedin: "NA",
  orcid: "NA",
  rg: "NA",
  website: "NA",
  aoi: "",
  education: "M.Tech",
  re: "NA",
  te: "NA",
  iece: "NA",
  articles: "NA",
  books: "N",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/DheerajNEW.png",  // Suggested filename after downloading from Drive
  name: "Mr. Dheeraj",
  position: "Lecturer",
  email: "dheeraj.soet@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/dheeraj-tanwar-1408a0293",
  orcid: "NA",
  rg: "NA",
  website: "NA",
  aoi: "Data analyst & Web Development",
  education: "MCA",
  re: "NA",
  te: "NA",
  iece: "NA",
  articles: "NA",
  books: "N",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
{
  img: "/assets/img/SOET/RAVI.png",  // Suggested filename after downloading from Drive
  name: "Mr. RAVI KUMAR",
  position: "Assistant Professor",
  email: "ravikumar.soet@mvn.edu.in",
  gs: "NA",
  linkedin: "https://www.linkedin.com/in/dheeraj-tanwar-1408a0293",
  orcid: "NA",
  rg: "NA",
  website: "NA",
  aoi: "web development & IOT",
  education: "M.Tech",
  re: "1 Year",
  te: "1 Year",
  iece: "1.5 Year",
  articles: "2",
  books: "N",
  chapters: "NA",
  patents: "NA",
  membership: "NA",
  aa1: "",
  aa2: "",
  aa3: "",
  aa4: "",
  aa5: "",
  aa6: ""
},
// {
//   img: "/assets/img/SOET/Sunil.png",  // Suggested filename after downloading from Drive
//   name: "Mr. Sunil",
//   position: "Assistant Professor",
//   email: "sunil.tanwar@mvn.edu.in",
//   gs: "NA",
//   linkedin: "https://www.linkedin.com/in/sunil-045944153/",
//   orcid: "NA",
//   rg: "NA",
//   website: "NA",
//   aoi: "Manufacturing Technology and automation, Composite Material ",
//   education: "NA",
//   re: "6 Month",
//   te: "10 Year",
//   iece: "NA",
//   articles: "2 International conference",
//   books: "N",
//   chapters: "NA",
//   patents: "NA",
//   membership: "NA",
//   aa1: "",
//   aa2: "",
//   aa3: "",
//   aa4: "",
//   aa5: "",
//   aa6: ""
// },
        /*{img:'/assets/img/SOET/rajeev_ratan.png',name:'Dr. Rajeev Ratan',position:'Professor & Registrar',email:'rajeev.arora@mvn.edu.in', gs: "https://shorturl.at/npRU1",
        linkedin: "https://shorturl.at/sxzBD",
        orcid: "https://orcid.org/0000-0003-1727-8108",
        rg: "https://www.researchgate.net/profile/Rajeev-Ratan",
        website: "#",
        aoi: " Digital Image Processing, Computer Vision,Multirate DSP, Agri-Electronics",
        education: "PhD (Electronics & Communication Engineering)",
        re: "5",
        te: "18",
        iece: "1",
        articles:
          "<li>Yogesh, A. K Dubey, Rajeev Ratan and A. Rocha, “Multiclass Classification of Nutrients Deficiency of Apple using Deep Neural Network”. Neural Computing & Applications-Springer (2020). https://doi.org/10.1007/s00521-020-05310-x (SCI Indexed; Impact Factor: 4.680).</li><li>Yogesh, A. K Dubey, R. Arora and A. Rocha, “Computer vision based analysis and detection of defects in fruits causes due to nutrients deficiency”, Cluster Computing, 1817–1826 (2020). https://doi.org/10.1007/s10586-019-03029-6 (SCI Indexed; Impact Factor: 1.9).</li><li>Rajeev Ratan, Sanjay Sharma, and Amit Kumar Kohli, “Performance Comparison of Quadrature Amplitude Modulation (QAM) Based Single and Double-stage Digital Interpolators,” International Journal of Electronics, Taylor & Francis, vol. 100, no. 12, pp. 1724- 1734, December 2013. (SCI Indexed; Impact Factor: 0.751</li>",
        books:
          "Main Author	:	Dr. Rajeev Ratan<br/>Co-author	:	Dr. Deepak Batra<br/>Publisher	:	ACME Learning Pvt. Ltd., New Delhi",
        chapters:
          "<li>Y. K. Chauhan and Rajeev Ratan, “Study on Placement of Sensors for Readings Accuracy Level Enhancement in Greenhouse,” Lecture Notes in Electrical Engineering, 2019, vol. 553, pp. 245-254. https://doi.org/10.1007/978-981-13-6772-4_22</li><li>Priyanka Kaushik, Rajeev Ratan, “A Novel Method to Detect the Tumor Using Low- Contrast Image Segmentation Technique,” Proceedings of International Conference on Computational Intelligence, pp 161–170, Part of the Algorithms for Intelligent Systems book series (AIS)- SPRINGER. DOI: 10.1007/978-981-16-3802-2_13</li><li>Sandeep Kumar, R. Ratan, J. V. Desai, “A Study of iOS Machine Learning and Artificial Intelligence Frameworks and Libraries for Cotton Plant Disease Detection,” Machine Learning, Advances in Computing, Renewable Energy and Communication pp 259–270. Part of the Lecture Notes in Electrical Engineering book series (LNEE,volume 768)- Springer Singapore, August 2021. https://doi.org/10.1007/978-981-16-2354-7_24</li>",
        patents:
          "<li>Dr. Alok Srivastava, Dr. Rajeev Ratan, “An Apparatus for secure and Consistent path selection in Wireless Cooperative Communication and Improved Method Thereof” Published 06/05/2022</li>",
        membership:
          "<li> Associate Member - Institution of Engineers (India) </li><li> Life Time Member of Indian Society of Technical Education</li><li>Life Time Member of Computer Society of India</li>",
        aa1: "Total Citations: 411",
        aa2: "h-indez: 9",
        aa3: "i10- index: 8",
        aa4: "",
        aa5: "",
        aa6: "",},*/
        /*{img:'/assets/img/SOET/amit_sagu.png',name:'Amit Sagu',position:'Assistant Professor',email:'amit.sagu@mvn.edu.in', gs: "https://scholar.google.com/citations?user=gy4TiZAAAAAJ&hl=en",
        linkedin: "http://www.linkedin.com/in/saguamit51",
        orcid: "https://orcid.org/0000-0002-0129-7665",
        rg: "http://www.researchgate.net/profile/Amit-Sagu",
        website: "#",
        aoi: " Machine Learning, Internet of Things (IoT)",
        education: "PhD (Computer Science)",
        re: "5",
        te: "5",
        iece: "2",
        articles:
          "<li>Amit Sagu, Nasib Singh Gill, Preeti Gulia, I. Priyadarshini and J. M. Chatterjee, \"Hybrid Optimization Algorithm for Detection of Security Attacks in IoT-Enabled Cyber-Physical Systems,\" in IEEE Transactions on Big Data, doi: 10.1109/TBDATA.2024.3372368.</li><li>Amit Sagu, Nasib Singh Gill, Preeti Gulia, Jyotir Moy Chatterjee, and Ishaani Priyadarshini. 2022. \"A Hybrid Deep Learning Model with Self-Improved Optimization Algorithm for Detection of Security Attacks in IoT Environment\" Future Internet 14, no. 10: 301. https://doi.org/10.3390/fi14100301.</li><li>Amit Sagu, Nasib Singh Gill, Preeti Gulia, Pradeep Kumar Singh, and Wei-Chiang Hong. 2023. \"Design of Metaheuristic Optimization Algorithms for Deep Learning Model for Secure IoT Environment\" Sustainability 15, no. 3: 2204. https://doi.org/10.3390/su15032204.</li>",
        books:
          "Amit Sagu. Cyber Security: Understanding the concept of cyber security, cybercrimes, cyber forensic and standard, ISBN: 9789389960952, Rudra Publication, 2020.",
        chapters:
          "N/A",
        patents:
          "Model for Detection of Security Attack in IoT Enabled Environment”, Inventors: Amit Sagu, Dr. Nasib Singh Gill and Dr. Preeti Gulia, Publication Date: 22 July 2022, Application No.: 202211040819 A.           ",
        membership:
          "N/A",
        aa1: "Reviewer, IEEE Access, 2024 – Present",
        aa2: "National Eligibility Test (N.E.T.), by Union Grant Commission (UGC) India, 2019",
        aa3: "National Eligibility Test (N.E.T.) with Junior Research Fellowship (JRF) by Union Grant Commission (UGC) India from 2018 – 2023.",
        aa4: "Reviewer, IEEE Access, 2024 – Present",
        aa5: "",
        aa6: "",},*/
        /*{img:'/assets/img/SOET/daya_shankar.png',name:'Daya Shankar Prasad',position:'Assistant Professor',email:'dayashankar.prasad@mvn.edu.in', gs: "https://scholar.google.com/citations?view_new_articles&hl4#d=gs",
        linkedin: "https://www.linkedin.com/in/daya-shankar-prasad-43171099",
        orcid: "https://orcid.org/0009-0004-8399-2910",
        rg: ":www.researchgate.net/profile/Daya-Prasad/research",
        website: "#",
        aoi: "Thermal Engineering, Nanomaterials, Heat transfer, Thermodynamics, Fluid Mechanics and   Solar Energy",
        education: "PhD* (Pursuing), M.Tech –Thermal (Gold Medalist-NIT Patna), MBA B.Tech-Mechanical Engineering (Branch Topper)",
        re: "N/A",
        te: "9",
        iece: "N/A",
        articles:
          "<li> Prasad. D. S and Singh P.K, “Thermal analysis of Graphene distributed in Sugar-Alcohol based PCM for Energy Storage System in a Heat Exchanger” during ICMME-2023 jointly organized by Department of Mechanical Engineering, GLA University, Mathura (India) and UFRGS, Porto Alegre (Brazil) held on 13th – 14th October 2023</li><li>Prasad. D. S, “Simulation of Radiation Source for Experimental Solar Pond”, paper presented in International Conference & Exhibition on Cutting Edge Technological Challenges (CETCME) in Mechanical Engineering held on 21-22 March. 2015.</li><li>Prasad D. S and Singh P.K, “Experimental Investigation of Salt-Gradient Solar-Pond using Halogen bulb as a Solar Simulator” Paper presented in 2nd International Conference on Campus to Corporate: Industry 4.0 at MVN University, Palwal on 14th March, 2024.</li>",
        books:
          "<li>Daya Shankar Prasad, “Heat Transfer” Published by Prime International Publishing House. ISBN No.-978-93-6010-436-8, 2023.</li><li>Daya Shankar Prasad, A textbook of Engineering Graphics” Published by Foundation Publishing House, Govind Mitra Road, Patna-80004. ISBN No.-978-93-89273-49-6. 2022</li>",
        chapters:
          "N/A",
        patents:
          "Design patent applied for “5G Industrial IoT enabled Cloud Manufacturing Security Service Architecture based on Fog Computing and Blockchain” Application no.- 202211031970.  https://iprsearch.ipindia.gov.in/PatentSearch/PatentSearch/ViewApplicationStatus",
        membership:
          "Member of IAENG",
        aa1: "Four times GATE Qualified with good percentile continuously from 2011 onward. ",
        aa2: "I.E.S Written Examination Qualified.",
        aa3: "Got Appreciation Certificate from IIT, BHU in honour of full support as Faculty Coordinator for Organising first round of Caliber “de-en-quete” from 31st March-1st April, 2018",
        aa4: "Got Certificate from IIT Roorkee (NPTEL) for completing a course on “Steam Power and Gas System” in 2020.",
        aa5: "Got Certificate from IIT Roorkee (NPTEL) for completing a course on “Refrigeration & Air Conditioning” in 2019.",
        aa6: "Got Certificate from IIT Kharagpur (NPTEL) for completing a course on on “Concept of Thermodynamics” in 2019.",
        aa7: "Got Certificate from NITTTR (NPTEL) for completing a course on “Quality Assurance through NAAC Accreditation process” in 2022.",
        aa8:"Gold Medalist for branch as well as NIT Patna’s topper in M.Tech. Programme. / Gold Medalist for branch topper in B.Tech Programme / Awarded for best student in 2009 by Indian Society for Technical Education. / Awarded for best new comer in 2006 by BGIET. / Awarded for Block topper in 10th class by MADHAVA MAHARUPI TRUST. "},*/
        
        // {img:'/assets/img/SOET/hema_rani.png',name:'Hema Rani',position:'Assistant Professor',email:'hemarani.cse@mvn.edu.in', gs: "#",
        // linkedin: "www.linkedin.com/in/hema-mangla-526031279",
        // orcid: "#",
        // rg: "#",
        // website: "#",
        // aoi: "Web Development",
        // education: "M.TECH (Computer Science)",
        // re: "0",
        // te: "10",
        // iece: "1",
        // articles:
        //   "<li> A.  Hema Rani,   Yogita Yashveer Raghav, Vaibhav Vyas “ Load Balancing using dynamic Algorithms for Cloud Environment: An Analysis,”  Materials Today: Proceedings, vol. </li>",
        // books:
        //   "N/A",
        // chapters:
        //   "N/A",
        // patents:
        //   "N/A",
        // membership:
        //   "N/A",
        // aa1: "National Eligibility Test (N.E.T.) by National Testing Agency (NTA) India, 2022.",
        // aa2: "Oracle Certified Professional, Java SE 6 Programmer, 2015.",
        // aa3: "Haryana Teacher Eligibility Test (H.T.E.T.) india, 2022.",
        // aa4: "",
        // aa5: "",
        // aa6: "",},
        /*{img:'/assets/img/SOET/manisha_mudgal.png',name:'Manisha Mudgal',position:'Assistant Professor',email:'manisha.mudgal@mvn.edu.in', gs: "#",
        linkedin: "https://www.linkedin.com/in/manisha-mudgal-b3a63661/",
        orcid: "https://orcid.org/0000-0001-5724-3159",
        rg: "https://www.researchgate.net/profile/Manisha-Mudgal",
        website: "#",
        aoi: " Machine Learning",
        education: "M.tech , PhD (Computer Science) Pursuing",
        re: "4+",
        te: "6",
        iece: "N/A",
        articles:
          "<li> Mudgal, Manisha, Deepika Punj, and Anuradha Pillai. \"Suspicious action detection in intelligent surveillance system using action attribute modelling.\" Journal of Web Engineering 20.1 (2021): 129-146.</li><li>Mudgal, Manisha, Deepika Punj, and Anuradha Pillai. \"Theoretical and empirical analysis of crime data.\" Journal of Web Engineering 20.1 (2021): 113-128.</li><li>Mudgal, Manisha, Deepika Punj, and Anuradha Pillai. \"A Novel Approach for Accident Detection and Localization Using Deep Learning.\" 2023 International Conference on Advances in Computation, Communication and Information Technology (ICAICCIT). IEEE, 2023.</li>",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "National Eligibility Test (N.E.T.) by Union Grant Commission (UGC) India, Dec 2019.",
        aa2: "HTET in Jan 2020.",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",}, */
        /*{img:'/assets/img/SOET/sanju_bala.png',name:'Sanju Bala',position:'Assistant Professor',email:'sanju.bala@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=new_articles&hl=en&imq=Sanju+Bala",
        linkedin: "http://www.linkedin.com/in/sanju-bala-5b4948301/",
        orcid: "https://orcid.org/0009-0006-0361-5037",
        rg: "https://www.researchgate.net/profile/Sanju-Bala-2",
        website: "http://sanjueng.blogspot.com/",
        aoi: "Theory of Computation, Compiler Design, Data Structure, Software Engineering, Operating System",
        education: "M.Tech (Computer Science)",
        re: "N/A",
        te: "6",
        iece: "N/A",
        articles:
          "<li>Research paper published in international journal of  Advanced Research in science and Engineering(ISSN-2319-8354)Title :  ” proposed surway on quality of service based resource over MANET”Issue Date:- 01-March-2015, Volume- 04, url-www.ijarse.com</li><li>Research paper published in international journal in Advanced Research in Science and engineering. (ISSN 2319-8954)Title: ”Automated Detection of fake profile” Issue Date:-01-may-2015,Volume- 04, Url- www.ijarse.com</li>",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "Qualified NIC  for Specialist Officer  in March 2024",
        aa2: "Qualified UGC NET dec 2020+june 2021 cycle",
        aa3: "Qualified HTET for PGT computer science",
        aa4: "Qualified Cucet in 2020 for Phd. for Central University of states including Haryana, Rajasthan and Punjab.",
        aa5: "Participated   in “XVII Senior National Kabaddi Championship” conducted by “Amateur Circle Kabaddi Federation of India” held in the year 2005.    ",
        aa6: "Achieved First Position in “2nd School Sports Competition” conducted by “Mewat Development Agency (MDA)” in the year 2004. ",
        aa7: "Achieved Second Position in the “XV National Circle Kabaddi Championship” conducted by “Kabaddi (CS) Federation of India” in the year 2004.",
        aa8: "Achieved First Position in “Javelin Throw” in the Athletic Meet organized by “SES Cardinals”, Sports Committee of School of Engineering and Sciences held in the year 2012.",
        aa9: "Achieved First Position in “Shot-put” in the Athletic Meet organized by “SES Cardinals”, Sports Committee of School of Engineering and Sciences held in the year 2012."},*/
        /*{img:'/assets/img/SOET/sumit.png',name:'Sumit',position:'Assistant Professor',email:'sumit.soet@mvn.edu.in', gs: "#",
        linkedin: "#",
        orcid: "https://orcid.org/0000-0002-8747-836X",
        rg: "https://www.researchgate.net/profile/Sumit-Sumit-12",
        website: "#",
        aoi: "IoT & Machine Learning",
        education: "Ph.D. Pursuing (Computer Science & Applications)",
        re: "5",
        te: "1",
        iece: "N/A",
        articles:
          "<li>Sumit, R. S. Chhillar, S. Dalal, S. Dalal, U. K. Lilhore, and S. Samiya, “A dynamic and optimized routing approach for VANET communication in smart cities to secure intelligent transportation system via a chaotic multi-verse optimization algorithm,” Cluster Comput., vol. 9, 2024, doi: 10.1007/s10586-024-04322-9. (Springer Nature, SCI Indexed with Impact Factor 4.4)</li><li>Sumit, Prof. Rajender Singh Chhillar and Sandeep Dalal (2023). Simulating MIMT Attackers’ Strategies in VANET to Secure ITS in Smart Cities via Multiverse Optimization-based Hybrid Routing Approach. International Journal on Recent and Innovation Trends in Computing and Communication, 11(10), 1326–1337. Retrieved from https://ijritcc.org/index.php/ijritcc/article/view/8675 (Scopus Indexed)</li><li>R. S. Chhillar and S. Dalal, “INTELLIGENT SYSTEMS AND APPLICATIONS IN ENGINEERING Secure Multiverse Optimization based Dynamic Routing Approach for Intelligent Transportation System in Smart Cities,” vol. 11, no. 2, pp. 252–261, 2023. (Scopus Indexed)</li><li>Sumit and Prof. Rajender Singh Chhillar (June 2022) “A Review of Intelligent Transportation System in Existing framework using IoT\", International Journal of Engineering Trends & Technology (IJETT, ISSN: 2231-5381, vol. 6, 2022 Page No. 137-143. https://ijettjournal.org/archive/ijett-v70i6p217</li>",
        books:
          "<li>Sumit, Prof. Rajender Singh Chhillar and Sandeep Dalal “Performance Analysis of Node Classification to Secure Intelligent Transportation System in VANET” Intelligent Systems for Smart Cities from 10.1007/978-981-99-6984-5_17(Scopus Indexed)</li><li>Sumit and R. S. Chhillar, \"IoT Enabled Security Management Approach for Intelligent Transportation System in Smart Cities,\" 2022 IEEE 6th Conference on Information and Communication Technology (CICT), Gwalior, India, 2022, pp. 1-5, doi: 10.1109/CICT56698.2022.9997813. (Scopus Indexed Proceedings)</li><li>Sumit and Prof. Rajender Singh Chhillar (September 2022 Accepted) “Comparative Analysis of Existing Security Techniques in Intelligent Transportation System\", International Conference on Data Science & Smart System to be Held in November 2022 (Scopus & Web of Science Proceedings.)</li>",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "National Eligibility Test (N.E.T.) by Union Grant Commission (UGC) India, December 2018        ",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},*/
        // {img:'/assets/img/SOET/poonam.jpg',name:'Poonam Dagar',position:'Assistant Professor',email:'poonam.dagar@mvn.edu.in', gs: "#",
        //   linkedin: "WWW.linkedin.com/in/poonam-dagar-a420762b1 ",
        //   orcid: "https://orcid.org/0009-0009-0833-3567",
        //   rg: "#",
        //   website: "#",
        //   aoi: "Machine Learning",
        //   education: "MCA (Computer Science)",
        //   re: "N/A",
        //   te: "1",
        //   iece: "N/A",
        //   articles:
        //     "N/A",
        //   books:
        //     "N/A",
        //   chapters:
        //     "N/A",
        //   patents:
        //     "N/A",
        //   membership:
        //     "N/A",
        //   aa1: "N/A",
        //   aa2: "",
        //   aa3: "",
        //   aa4: "",
        //   aa5: "",
        //   aa6: "",},
          /*{img:'/assets/img/SOET/babita.jpg',name:'Babita Yadav',position:'Assistant Professor',email:'babita.yadav@mvn.edu.in', gs: "#",
            linkedin: "https://www.linkedin.com/in/babita-yadav-49973a7a/",
            orcid: "https://orcid.org/0000-0003-4524-2452",
            rg: "#",
            website: "#",
            aoi: "Blockchain",
            education: "Pursuing PhD (Computer Science)",
            re: "4",
            te: "19",
            iece: "0.5",
            articles:
              "<li>a)\“Comparative cost analysis of on-chain and off-chain immutable data storage using blockchain for healthcare data” 6th International Conference on ICT for Intelligent Systems (ICTIS – 2022) DOI:https://link.springer.com/chapter/10.1007/978-981-19-3575-6_74</li><li>b)	      \"Health Care Transformation Traditional to Telemedicine : A Portrayal \"\"paper accepted in international conference on Emerging Technologies for Computing, Communication and smart cities(ETCCS-2021).DOI: ttps://link.springer.com/chapter/10.1007/978-981-19-0284-0_1</li><li>c)	 \“Economics of immutability preserving streaming healthcare data storage using aggregation in blockchain technology \“ Conference SmartCom 2021 - Springer - Jaipur https://link.springer.com/book/9789811699689\"</li>",
            books:
              "N/A",
            chapters:
              "<li>I.	 A. Sagu, N. S. Gill, and P. Gulia, “Hybrid Deep Neural Network Model for Detection of Security Attacks in IoT Enabled Environment,” Int. J. Adv. Comput. Sci. Appl. IJACSA, vol. 13, no. 1, Art. no. 1, 55/31 2022, doi: 10.14569/IJACSA.2022.0130115.</li><li>II.	 A. Sagu, N. S. Gill, and P. Gulia, “Hybrid Deep Neural Network Model for Detection of Security Attacks in IoT Enabled Environment,” Int. J. Adv. Comput. Sci. Appl. IJACSA, vol. 13, no. 1, Art. no. 1, 55/31 2022, doi: 10.14569/IJACSA.2022.0130115</li><li>III.	 A. Sagu, N. S. Gill, and P. Gulia, “Hybrid Deep Neural Network Model for Detection of Security Attacks in IoT Enabled Environment,” Int. J. Adv. Comput. Sci. Appl. IJACSA, vol. 13, no. 1, Art. no. 1, 55/31 2022, doi: 10.14569/IJACSA.2022.0130115</li>",
            patents:
              "<li>I.	Model for Detection of Security Attack in IoT Enabled Environment, Inventors: Amit Sagu, Dr. Nasib Singh Gill and Dr. Preeti Gulia, Publication Date: 22 July 2022, Application No.: 202211040819 A, [Online] Available: https://search.ipindia.gov.in/IPOJournal/Journal/ViewJournal</li><li>II.	Model for Detection of Security Attack in IoT Enabled Environment”, Inventors: Amit Sagu, Dr. Nasib Singh Gill and Dr. Preeti Gulia, Publication Date: 22 July 2022, Application No.: 202211040819 A, [Online] Available: https://search.ipindia.gov.in/IPOJournal/Journal/ViewJournal</li>",
            membership:
              "N/A",
            aa1: "I.	National Eligibility Test (N.E.T.) by Union Grant Commission (UGC) India, 2017.",
            aa2: "II.	National Eligibility Test (N.E.T.) with Junior Research   Fellowship (JRF) by Union Grant Commission (UGC) India from 2018 – 2023.",
            aa3: "III.	National Eligibility Test (N.E.T.), by Union Grant Commission (UGC) India, 2019",
            aa4: "",
            aa5: "",
            aa6: "",},*/
          // {img:'/assets/img/SOET/rashi.jpg',name:' Rashi Singh',position:'Assistant Professor',email:'rashi.singh@mvn.edu.in', gs: "#",
          //   linkedin: "www.linkedin.com/in/rashi-singh-136778271",
          //   orcid: "https://orcid.org/0000-0002-6440-8318",
          //   rg: "https://www.researchgate.net/profile/Rashi-Singh-13 ",
          //   website: "#",
          //   aoi: "Machine Learning",
          //   education: "Ph.D. (Computer Science)",
          //   re: "3",
          //   te: "2",
          //   iece: "3",
          //   articles:
          //     "<li>\" 1.	Singh, Rashi & Gill, Nasib & Gulia, Preeti. (2022). A Comparative Performance Analysis of Modeling and Simulation Tools for Smart Grid. International Journal of Engineering Trends and Technology. 70. 332-342. 10.14445/22315381/IJETT-V70I4P229.</li><li>2.	Singh, Rashi & Gill, Nasib & Gulia, Preeti. (2021). A SYSTEMATIC REVIEW OF SECURITY IN SMART GRID INFRASTRUCTURE. Journal of Theoretical and Applied Information Technology. 99. 5701.</li><li>3.	Singh, Rashi & Gill, Nasib. (2020). Use of IoT and Machine Learning for Efficient Power Management Through Smart Grid: A Review. International Journal of Advanced Science and Technology. 29. 8982-8990.\"</li>",
          //   books:
          //     "<li>Rashi Singh. Artificial Intelligence and Machine learning, ISBN: 978-81-968875-2-0, Chendur Publishing House, Chennai, 2024</li>",
          //   chapters:
          //     "<li>R. Singh, N. S. Gill, and P. Gulia, “The Security of Smart Grid: An Overview,” International Book “Multidisciplinary Subjects for Research”- Xi Vol-1, ISBN: 978-1-365-59978-1, September 2021</li>",
          //   patents:
          //     "<li>\"I.	IoT based anxiety detection wrist band\”, Inventors:  Anuj Kumar, Mr. MUKULIT GOEL, Rashi Singh, Ruchika  Publication Date:  2 February 2024, Application No.:  202411001207, [Online] Available: https://iprsearch.ipindia.gov.in/PatentSearch/PatentSearch/ViewApplicationStatus </li><li>II.	AN ANALYSIS AND DESIGN OF SECURITY ALGORITHMS IN IOT ENABLED SMART GRID”, Inventors: Rashi Singh, Dr. Nasib Singh Gill and Dr. Preeti Gulia, Publication Date: 23 February 2024, Application No.: 202311088665 A, [Online] Available:  https://iprsearch.ipindia.gov.in/PublicSearch/PublicationSearch/Search </li>\"",
          //   membership:
          //     "N/A",
          //   aa1: "National Eligibility Test (N.E.T.) by Union Grant Commission (UGC) India, 2019.",
          //   aa2: "Reviewer in International Journal of Electrical and Computer Engineering Systems (IJECES) Scopus, Web of Science",
          //   aa3: "",
          //   aa4: "",
          //   aa5: "",
          //   aa6: "",},
       /* {img:'/assets/img/SOET/dheeraj.png',name:'dheeraj',position:'Teaching Assistant',email:'dheeraj.cse@mvn.edu.in', gs: "#",
        linkedin: "https://www.linkedin.com/in/mr-dheeraj-singh-71941a246",
        orcid: "#",
        rg: "#",
        website: "#",
        aoi: " Operating System",
        education: "Msc (Computer Science)",
        re: "N/A",
        te: "2",
        iece: "N/A",
        articles:
          "N/A",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "N/A",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},*/
       /* {img:'/assets/img/SOET/sagar_sharma.png',name:'Sagar Sharma',position:'Teaching Assistant',email:'sagar.sharma@mvn.edu.in', gs: "https://scholar.google.com/citations?hl=en&user=k8zz7CwAAAAJ",
        linkedin: "www.linkedin.com/in/sagar-sharma-94bb6324b",
        orcid: "https://orcid.org/0009-0002-1368-8636",
        rg: "https://www.researchgate.net/profile/Sagar-Sharma-29",
        website: "#",
        aoi: " Machine Learning",
        education: " M.sc (Computer Science)",
        re: "N/A",
        te: "0.5",
        iece: "0.5",
        articles:
          "N/A",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "N/A",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},*/

      /*{
        img: "/assets/img/SOET/default_profile.png",  // Replace with actual profile photo if available
        name: "Sumit",
        position: "Assistant Professor",
        email: "sumit.soet@mvn.edu.in",
        gs: "NA",
        linkedin: "https://www.linkedin.com/in/sumit-kumar-65350130b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        orcid: "https://orcid.org/0000-0002-8747-836X",
        rg: "https://www.researchgate.net/profile/Sumit-Sumit-12?ev=hdr_xprf",
        website: "NA",
        aoi: "IOT & Machine Learning",
        education: "Ph.D. Pursuing",
        re: "6 Years",
        te: "6 Years",
        iece: "NA",
        articles: "10",
        books: "NA",
        chapters: "1",
        patents: "1 Published",
        membership: "NA",
        aa1: "UGC NET Dec. 2018",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: ""
      },*/
  
// {
//   img: "/assets/img/SOET/susheel_kumar.jpg",  // Suggested filename after downloading from Drive
//   name: "Susheel Kumar",
//   position: "Assistant Professor",
//   email: "susheel.kumar@mvn.edu.in",
//   gs: "https://scholar.google.com/citations?view_op=new_profile&hl=en",
//   linkedin: "https://www.linkedin.com/in/susheel-kumar-0b5347188/",
//   orcid: "NA",
//   rg: "https://www.researchgate.net/profile/Susheel-Kumar-46?ev=hdr_xprf",
//   website: "https://susheelportfolio.wixsite.com/myportfolio",
//   aoi: "Machine Learning/AI",
//   education: "PhD Pursuing",
//   re: "NA",
//   te: "2",
//   iece: "1",
//   articles: "NA",
//   books: "NA",
//   chapters: "NA",
//   patents: "NA",
//   membership: "NA",
//   aa1: "University Silver medalist in MCA",
//   aa2: "",
//   aa3: "",
//   aa4: "", 
//   aa5: "",
//   aa6: ""
// }




// {
//   img: "/assets/img/SOET/loveneet_makhija.png",  // Suggested filename after downloading from Drive
//   name: "Loveneet Makhija",
//   position: "Teaching Assistant",
//   email: "loveneet.makhija@mvn.edu.in",
//   gs: "NA",
//   linkedin: "https://www.linkedin.com/in/loveneet-makhija-a910351ab/",
//   orcid: "NA",
//   rg: "NA",
//   website: "NA",
//   aoi: "Web Development, Machine Learning",
//   education: "MCA",
//   re: "NA",
//   te: "NA",
//   iece: "NA",
//   articles: "NA",
//   books: "NA",
//   chapters: "NA",
//   patents: "NA",
//   membership: "NA",
//   aa1: "",
//   aa2: "",
//   aa3: "",
//   aa4: "",
//   aa5: "",
//   aa6: ""
// },


// {
//   img: "/assets/img/SOET/happy_tanwar.png",  // Suggested filename after downloading from Drive
//   name: "Happy Tanwar",
//   position: "Assistant Professor",
//   email: "happy.tanwar@mvn.edu.in",
//   gs: "NA",
//   linkedin: "https://www.linkedin.com/in/happy-tanwar-58b533245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//   orcid: "NA",
//   rg: "NA",
//   website: "NA",
//   aoi: "App/Web Development, Machine Learning",
//   education: "B. Tech (IT), M. Sc. (CS)",
//   re: "NA",
//   te: "5+ Yrs (As a PGT Lecturer) & 2 Months (As an AP)",
//   iece: "2+",
//   articles: "NA",
//   books: "NA",
//   chapters: "NA",
//   patents: "NA",
//   membership: "NA",
//   aa1: "UGC NET Dec. 2022",
//   aa2: "",
//   aa3: "",
//   aa4: "",
//   aa5: "",
//   aa6: ""
// },

// {
//   img: "/assets/img/SOET/megha_sharma.png",  // Suggested filename after downloading from Drive
//   name: "Megha Sharma",
//   position: "Assistant Professor",
//   email: "megha.sharma@mvn.edu.in",
//   gs: "NA",
//   linkedin: "NA",
//   orcid: "NA",
//   rg: "NA",
//   website: "NA",
//   aoi: "Computer networks, IOT",
//   education: "MCA",
//   re: "NA",
//   te: "2 years",
//   iece: "NA",
//   articles: "NA",
//   books: "NA",
//   chapters: "NA",
//   patents: "NA",
//   membership: "NA",
//   aa1: "MDU 5th rank holder in B.Sc (H) CS , MDU 9th rank holder in MCA",
//   aa2: "",
//   aa3: "",
//   aa4: "",
//   aa5: "",
//   aa6: ""
// },




    ]
return(
    <Grid container spacing={2} sx={{margin:'10px 0px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <MainTitle title='Computer Science and Engineering Faculties'/>
        </Grid>
        {facultyList?.map((fac)=>(
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FacultyCard faculty={fac} />
        </Grid>
        ))}
    </Grid>
)
}
export default FacultyList;